<template>
<div class="fileuploaderlist float-left float-clear">
  <div class="margin-left-1Point5Perc">
    <div>
      <div class="col-sm-2 col-md-2 col-lg-2 text-wrap height-150px width-170px border-1px margin-top-3Perc margin-right-1Perc hover-border"> 
        <div class="height-100Perc" v-if="getFileType === 0">
          <!-- PDF -->
          <img :src="copyicon" alt="iconCopy" class="img-responsive img-align height-15Px width-15 img-opacity image-edit-zindex-2 cursor-pointer" @click="copyText">
          <img :src="iconEdit" alt="iconEdit" class="img-responsive img-align height-15Px width-13 img-opacity image-edit-zindex-1 cursor-pointer" @click="showEditFileOverlay">
          <img :src="iconDelete" alt="iconDelete" class="img-responsive img-align height-15Px width-13 img-opacity image-delete-zindex-1 cursor-pointer" @click="showConfirmationBeforeDelete">
          <a class="cursor-pointer"><img :src="iconpdf" @click="showViewPDFFileOverlay" alt="pdficon" class="img-responsive img-align height-100Perc width-60 img-opacity"></a>
        </div>
        <div class=" height-100Perc" v-if="getFileType === 1">
          <!-- IMAGE -->
          <img :src="copyicon" alt="iconCopy" class="img-responsive img-align height-15Px width-15 img-opacity image-edit-zindex-2 cursor-pointer" @click="copyText">
          <img :src="iconEdit" alt="iconEdit" class="img-responsive img-align height-15Px width-13 img-opacity image-edit-zindex-1 cursor-pointer" @click="showEditFileOverlay">
          <img :src="iconDelete" alt="iconDelete" class="img-responsive img-align height-15Px width-13 img-opacity image-delete-zindex-1 cursor-pointer" @click="showConfirmationBeforeDelete">
          <a class="cursor-pointer"><img :src="iconImage" @click="showViewImageFileOverlay" alt="imgeicon" class="img-responsive img-align height-100Perc img-opacity width-90px"></a>
        </div>
      </div>  
      <div class=" text-wrap col-sm-2 col-md-2 col-lg-2 height-20px width-170px padding-left-0Perc padding-right-0Perc">
        <div class="tooltip1"><span class="text-align-center cursor-pointer">{{truncateName(getFileName)}}</span> 
          <span class="tooltiptext"><b>File Name: </b> {{getFileName}} <br> <b>Uploaded:</b> {{formatAndShowDate(getFileCreateTS)}} <br> <b>Modified:</b> {{formatAndShowDate(getFileUpdatedTS)}}</span>
        </div>
      </div>
      
      <!--display on overlay  -->
        <!-- <div class="col-sm-2 col-md-2 col-lg-2  height-60px width-170px padding-left-0Perc padding-right-0Perc text-align-left">
          <b>Uploaded:</b> {{formatAndShowDate(getFileCreateTS)}}
        </div>
        <div class="col-sm-2 col-md-2 col-lg-2 height-60px width-170px padding-left-0Perc padding-right-0Perc text-align-left">
          <b>Modified:</b> {{formatAndShowDate(getFileUpdatedTS)}}
        </div> -->
      <!--  -->
    </div>
  </div>
  <div id="snackbar">Link Copied to clipboard.</div>
  <!-- Show Spinner -->
  <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
  </div>
  <loader></loader>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteFileString" v-bind:postfixString="postDeleteFileString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedFile"></confirmation-alert>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
  <update-uploaded-file-overlay v-if="isEditFileOverlayVisible" @closeOverlay="closeEditFileOverlay" v-bind:fileObj="fileObj" @refreshList="refreshFileList"></update-uploaded-file-overlay> 
  <view-pdf-file-overlay v-if="isViewPdfFileOverlayVisible" @closeOverlay="closeViewPDFFileOverlay" v-bind:fileObj="fileObj"></view-pdf-file-overlay>
  <copy-link-to-Clipboard v-if="isCopylinkToClipboardOverlayVisible" @closeOverlay="closeCopylinkToClipboardOverlay" v-bind:fileObj="fileObj"></copy-link-to-Clipboard>
  <view-image-file-overlay v-if="isViewImageFileOverlayVisible" @closeOverlay="closeViewImageFileOverlay" v-bind:fileObj="fileObj"></view-image-file-overlay>
</div>

</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import iconImage from '../assets/images/iconimage.svg'
import iconpdf from '../assets/images/iconpdf.svg'
import copyIcon from '../assets/images/copyicon.svg'
import iconEdit from '../assets/images/edit.svg'
import iconDelete from '../assets/images/delete.svg'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import CopyLinkToClipboardOverlay from '@/components/CopyLinkToClipboardOverlay'
import UpdateUploadedFileOverlay from '@/components/UpdateUploadedFileOverlay'
import ViewPdfFileOverlay from '@/components/ViewPdfFileRepositoryOverlay'
import ViewImageFileOverlay from '@/components/ViewImageFileRepositoryOverlay'
import { fileUploadService } from '@/server-util/file-upload-service'
export default {
  props: ['fileObj'],
  data: function () {
    return {
      iconImage: iconImage,
      iconpdf: iconpdf,
      iconDelete: iconDelete,
      iconEdit: iconEdit,
      copyicon: copyIcon,
      showConfirmationBox: false,
      prefixDeleteFileString: '',
      postDeleteFileString: '',
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      isCopylinkToClipboardOverlayVisible: false,
      isEditFileOverlayVisible: false,
      isViewPdfFileOverlayVisible: false,
      isViewImageFileOverlayVisible: false,
      postCopyMsg: '',
      isCopiedSuccessfully: false
    }
  },
  methods: {
    copyText: function () {
      const textToCopy = this.getFileUrl
      this.isCopiedSuccessfully = false
      // AK: Create textarea element
      const textarea = document.createElement('textarea')
      // AK: Set the value of the text
      textarea.value = textToCopy
      // AK: Making it readonly
      textarea.setAttribute('readonly', '')
      // AK: Hide the textarea off the screen
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      // AK: Add the textarea to the page
      document.body.appendChild(textarea)
      // AK: Copy the textarea
      textarea.select()
      try {
        var successful = document.execCommand('copy')
        this.isCopiedSuccessfully = successful
      } catch (err) {
        this.isCopiedSuccessfully = false
      }
      textarea.remove()
      // this.postCopyMsg = this.isCopiedSuccessfully ? 'Link Copied to clipboard.' : 'Fail to copy link.'
      // alert(this.postCopyMsg)
      // alert(this.isCopiedSuccessfully)
      var _this = this
      setTimeout(function () {
        _this.showToastMsg()
      }, 200)
    },
    showToastMsg: function () {
      var x = document.getElementById('snackbar')
      x.className = 'show'
      setTimeout(function () {
        x.className = x.className.replace('show', '')
        this.isCopiedSuccessfully = false
      }, 3000)
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    refreshFileList (value) {
      // AK: After successfully performed edit operation, refresh List
      this.$emit('refreshList', true)
    },
    closeEditFileOverlay (value) {
      // AK: Used to close the Edit File Uplod overlay
      this.isEditFileOverlayVisible = value
      // AK: Enable Background scrolling
      this.$store.state.isOverlayVisible = value
    },
    showEditFileOverlay: function () {
      // AK: Used to open the Edit File Uplod overlay
      this.isEditFileOverlayVisible = true
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = true
    },
    showcopylinkToClipboardOverlay () {
      // AK: Used to open the Edit File Uplod overlay
      this.isCopylinkToClipboardOverlayVisible = true
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = true
    },
    closeCopylinkToClipboardOverlay (value) {
      // AK: Used to open the Edit File Uplod overlay
      this.isCopylinkToClipboardOverlayVisible = value
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = value
    },
    showViewPDFFileOverlay: function () {
      // AK: Used to open the View PDF File overlay
      this.isViewPdfFileOverlayVisible = true
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = true
    },
    closeViewPDFFileOverlay (value) {
      // AK: Used to close the view PDF File overlay
      this.isViewPdfFileOverlayVisible = value
      // AK: Enable Background scrolling
      this.$store.state.isOverlayVisible = value
    },
    showViewImageFileOverlay: function () {
      // AK: Used to open the View Image File overlay
      this.isViewImageFileOverlayVisible = true
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = true
    },
    closeViewImageFileOverlay (value) {
      // AK: Used to close the view PDF File overlay
      this.isViewImageFileOverlayVisible = value
      // AK: Enable Background scrolling
      this.$store.state.isOverlayVisible = value
    },
    showConfirmationBeforeDelete: function () {
      // AK: Show warning msg before delete
      this.showConfirmationBox = true
      this.prefixDeleteFileString = 'Are you sure you want to delete '
      this.postDeleteFileString = '\'' + this.getFileName + '\' file?'
    },
    deleteSelectedFile (value) {
      this.showConfirmationBox = false
      var storeObj = this.$store
      if (this.fileObj !== undefined) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        fileUploadService.deleteFile(storeObj.state.access_token, this.fileObj.FileId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              // AK: Refresh List again (FileUploader file)
              this.$emit('refreshList', true)
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
          })
      } else {
        console.log('FileId IS NULL HENCE DECLINE DELETE SELECTED FILES OPERATION')
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    truncateName: function (fileName) {
      if (fileName.length > 19) {
        return dmAdminUtils.truncateString(fileName, 19) + '...'
      }
      return fileName
    },
    copylinkToClipboard () {
      // var copyText = window.location.href
      // copyText.select()
      // document.execCommand('copy')
      // alert('Copied the text: ' + copyText.value)
      // alert(window.location.href)
      // alert(this.fileObj.FileUrl)
      // var copyUrl = window.getSelection(this.fileObj.FileUrl)
      // window.getSelection.select(copyUrl)

      // alert('Copied the URL: ' + this.fileObj.FileUrl)
      // var copyUrl = String(this.fileObj.FileUrl)
      // copyUrl.select()
      // document.execCommand('copy')
      // alert('Copied the text: ' + copyUrl.value)
    }
  },
  computed: {
    getPostCopyMessage: {
      get: function () {
        return this.postCopyMsg
      }
    },
    getFileName: {
      get: function () {
        // console.log(JSON.stringify(this.fileObj))
        return this.fileObj.FileName
      }
    },
    getFileCreateTS: {
      get: function () {
        return this.fileObj.CreatedTS
      }
    },
    getFileUpdatedTS: {
      get: function () {
        return this.fileObj.UpdatedTS
      }
    },
    getFileType: {
      get: function () {
        return this.fileObj.FileType
      }
    },
    getFileUrl: {
      get: function () {
        return this.fileObj.FileUrl
      }
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'update-uploaded-file-overlay': UpdateUploadedFileOverlay,
    'copy-link-to-Clipboard': CopyLinkToClipboardOverlay,
    'view-pdf-file-overlay': ViewPdfFileOverlay,
    'view-image-file-overlay': ViewImageFileOverlay,
    'loader': Loader
  },
  name: 'fileuploaderlist'
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.cursor-pointer{
  cursor: pointer;
}
.fileuploaderlist {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.margin-left-1Point5Perc{
  margin-left: 1.5%;
}
.positionrel
{
  position: relative;
}

.background-color-red
{
	background-color: red;
}
.background-color-yellow
{
	background-color: yellow;
}
.cf-border
{
	border:1px solid black;
}
.left-color-border
{
	border: 1px solid red;
}
.right-color-border
{
	border: 1px solid green;
}
.leftNavBarBG
{
	background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px{
	font-size: 30px;
}
.position-Fixed
{
	position:fixed;
}
.float-Right
{
	float: right;
}
.fullHeight
{
	height:100% !important;
}
.fi-border
{
	border: 1px solid white;
}
 .footer-img
 {
    margin: 0 auto !important;
    display: block;
    position: absolute;
    bottom: 0;
	width: 30%;
 }
 .center-block {
   margin-left:auto;
   margin-right:auto;
   display:block;
}
.text-center {
   text-align:center;
}
.margin-Top-14Perc
{
	margin-top: 14%;
}
.margin-Top-0Point5Perc
{
	margin-top: 0.5%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-Top-5Perc
{
	margin-top: 5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.text-align-left
{
  text-align: left;
}
.text-align-center
{
  text-align: center !important;
  margin: 0 auto !important;
}
.margin-Left-4Perc
{
  margin-left: 4%;
}
.margin-Left-3Perc
{
  margin-left: 3%;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
.font-size-18px{
    font-size: 18px;
}
.padding-15px{
    padding: 15px;
}
.border-1px{
    border: 1px solid #ccc;
}
.height-80Perc{
  height:80px;
}
.height-12Px{
 height:12px; 
}
.height-15Px{
 height:15px; 
}
.height-30Px{
 height:30px; 
}
.height-70px{
 height:70px; 
}
.height-100Perc{
  height:100%;
}
.height-80Perc{
  height:80%;
}
.height-150px{
 height: 175px;
}
.textheight-150px{
 height: 150px;
}
.width-60{
  width:60px;
}
.width-40{
  width:40px;
}
.width-13{
  width:13px;
}
.width-15{
  width:15px;
}
.width-150px{
  width: 150px;
}
.width-170px{
  width: 170px;
}
.height-50-width-50px{
  height: 50px;
  width: 150px;
}
.margin-right-1Perc{
  margin-right: 1%;
}
.margin-right-3Perc{
  margin-right: 3%;
}
.display-block{
  display: block;
}
.margin-bottom-10Perc{
  margin-bottom: 110px;
}
.margin-top-3Perc{
  margin-top: 30px;
}
.text-overflow{
 text-overflow: ellipsis !important;
}
.text-wrap {
    /* width: 11em;  */
    /* border: 1px solid #000000; */
    word-wrap: break-word !important;
    /* text-align: justify; */
}
.padding-left-0Perc{
  padding-left: 0%; 
}
.padding-right-0Perc{
  padding-right: 0%; 
}
.float-left{
  float: left !important;
  /* clear:right !important; */
}
.height-50px{
  height:50px;
}
.height-50px{
height:"50px";
}
.img-align{
    display: block;
    margin-left: auto;
    margin-right: auto;
    /* width: 40%; */
}
.img-opacity{
  opacity:0.7;
}
.image-edit-zindex-1{
    position: absolute;
    left: 133px;
    top: 5px;
    z-index: 1;
}
.image-edit-zindex-2{
    position: absolute;
    left: 114px;
    top: 5px;
    z-index: 1;
}
.image-delete-zindex-1{
position: absolute;
    left: 150px;
    top: 5px;
    z-index: 1;
}
.width-90px{
  width:90px
}
.float-clear{
   clear:right !important;
}
.tooltip1 {
    position: relative !important;
    display: inline-block !important;
    /* border-bottom: 1px dotted black !important; */
}
.tooltip1 .tooltiptext {
    visibility: hidden;
    width: 235px;
    background-color: #696969;
    /* opacity:0.8; */
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 5px 5px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
}
.tooltip1:hover .tooltiptext {
    visibility: visible;
}
.height-20px{
  height:20px !important;
}
.hover-border:hover{
  border: 1px solid #777;
}
.border-red {
  border: 1px solid red;
}
/* The snackbar - position it at the bottom and in the middle of the screen */
#snackbar {
  visibility: hidden; /* Hidden by default. Visible on click */
  min-width: 250px; /* Set a default minimum width */
  margin-left: -125px; /* Divide value of min-width by 2 */
  background-color: #333; /* Black background color */
  color: #fff; /* White text color */
  text-align: center; /* Centered text */
  border-radius: 2px; /* Rounded borders */
  padding: 16px; /* Padding */
  position: fixed; /* Sit on top of the screen */
  z-index: 1; /* Add a z-index if needed */
  left: 50%; /* Center the snackbar */
  bottom: 30px; /* 30px from the bottom */
}

/* Show the snackbar when clicking on a button (class added with JavaScript) */
#snackbar.show {
  visibility: visible; /* Show the snackbar */
  /* Add animation: Take 0.5 seconds to fade in and out the snackbar. 
  However, delay the fade out process for 2.5 seconds */
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
  from {bottom: 0; opacity: 0;} 
  to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}

@-webkit-keyframes fadeout {
  from {bottom: 30px; opacity: 1;} 
  to {bottom: 0; opacity: 0;}
}

@keyframes fadeout {
  from {bottom: 30px; opacity: 1;}
  to {bottom: 0; opacity: 0;}
}
</style>



// WEBPACK FOOTER //
// src/components/FileUploadList.vue